  import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import SuperAdminLayout from './SuperAdminLayout';
import SuperAdminOverview from './pages/SuperAdminOverview';
import ProfessionalsList from './pages/ProfessionalsList';
import ProfessionalHistory from './pages/ProfessionalHistory';
import ClientsList from './pages/ClientsList';
import SalonsList from './pages/SalonsList';
import SalonDetail from './pages/SalonDetail';
import UsersList from './pages/UsersList';
import Subscriptions from './pages/Subscriptions';
import BansList from './pages/BansList';
import NoShowsList from './pages/NoShowsList';
import MessagingPage from './pages/MessagingPage';

const SuperAdminApp = () => {
  return (
    <SuperAdminLayout>
      <Routes>
        <Route path="/" element={<Navigate to="overview" replace />} />
        <Route path="overview" element={<SuperAdminOverview />} />
        <Route path="professionals" element={<ProfessionalsList />} />
        <Route path="professionals/:professionalId/history" element={<ProfessionalHistory />} />
        <Route path="clients" element={<ClientsList />} />
        <Route path="salons" element={<SalonsList />} />
        <Route path="salons/:salonId" element={<SalonDetail />} />
        <Route path="users" element={<UsersList />} />
        <Route path="subscriptions" element={<Subscriptions />} />
        <Route path="messaging" element={<MessagingPage />} />
        <Route path="bans" element={<BansList />} />
        <Route path="no-shows" element={<NoShowsList />} />
        <Route path="*" element={<Navigate to="overview" replace />} />
      </Routes>
    </SuperAdminLayout>
  );
};

export default SuperAdminApp;
